import { useQuery } from "@tanstack/react-query";
import { PageHeader, Section, StatBadge } from "@/components/Chrome";
import { api } from "@/lib/api";

export default function ActivityLog() {
  const { data: items = [] } = useQuery({ queryKey: ["activity", "full"], queryFn: () => api.activity.list(200), refetchInterval: 5000 });
  return (
    <div data-testid="activity-page">
      <PageHeader eyebrow="Audit trail" title="Activity log" subtitle="Every decision, message and background trigger — chronologically, most recent first." />
      <Section title={`${items.length} entries`}>
        {items.length === 0 ? (
          <div className="text-sm text-stone-500">No activity yet.</div>
        ) : (
          <ul className="divide-y divide-stone-800/70" data-testid="activity-log">
            {items.map((a) => (
              <li key={a.id} className="py-3 grid grid-cols-12 gap-4 items-start" data-testid={`activity-${a.id}`}>
                <span className="col-span-2 font-mono text-[11px] text-stone-500">{new Date(a.ts).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
                <span className="col-span-1"><StatBadge status={a.status === "success" ? "success" : a.status === "warning" ? "warning" : a.status === "danger" ? "danger" : "info"}>{a.kind}</StatBadge></span>
                <div className="col-span-9">
                  <div className="text-sm text-stone-200">{a.summary}</div>
                  {a.detail && <pre className="text-[11px] text-stone-500 mt-1 font-mono whitespace-pre-wrap">{a.detail}</pre>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </Section>
    </div>
  );
}
